<div class="flex row-collapse items-center space-between">
  <span class="title-header mb-27">{{ 'profiles.sales-opportunities.header' | translate | titlecase }}</span>
  <button pButton type="button" *ngIf="profileContactsTabFullAccess"
    class="mct-flex atlas-btn atlas-btn-primary mct-justify-center mct-items-center" type="button" (click)="salesOppDialog.open()">
    <i class="large-icon pi pi-plus"></i>
    <span>{{ 'profiles.sales-opportunities.add-a-sales-opportunity' | translate | uppercase }}</span>
  </button>
</div>

<wl-sales-opportunity-edit-dialog #salesOppDialog></wl-sales-opportunity-edit-dialog>

<div class="params-container mb-20">
  <div class="search-header mb-32">{{ 'profiles.sales-opportunities.search-sales-opportunities' | translate | titlecase
    }}</div>
  <wl-sales-opportunity-search-params [searchParams]="searchParams"></wl-sales-opportunity-search-params>
  <div class="mt-33 mct-flex mct-row mct-justify-end mct-items-center">
    <button pButton type="button" class="atlas-btn atlas-btn-primary" (click)="searchGrid.search()">
      {{ 'profiles.sales-opportunities.run-this-search' | translate | uppercase }}
    </button>
  </div>
</div>

<div class="divider-bar mb-21 mct-flex mct-row mct-justify-end mct-items-center">
  <span *ngIf="!salesOpportunitySearchResult?.TotalCount; else resultsReturned" class="no-results">
    {{ 'web-content.search-grid.no-search-results' | translate | ucfirst }}
  </span>
  <ng-template #resultsReturned>
    <span>{{ 'profiles.sales-opportunities.the-search-returned' | translate | ucfirst }}</span>
    &nbsp;
    <span class="f-wb">{{ salesOpportunitySearchResult.TotalCount }}</span>
    &nbsp;
    <span class="f-wb">{{ 'profiles.sales-opportunities.sales-opportunities' | translate }}</span>
  </ng-template>
  <button pButton type="button" class="mct-flex ml-10 atlas-btn atlas-btn-secondary mct-justify-center mct-items-center" type="button"
    (click)="clear()">
    <i class="large-icon pi pi-times"></i>
    <span>{{ 'profiles.sales-opportunities.clear-search' | translate | uppercase }}</span>
  </button>
</div>

<wl-sales-opportunity-search-grid #searchGrid [searchParams]="searchParams"
  (completedSearch)="salesOpportunitySearchResult = $event"></wl-sales-opportunity-search-grid>
